import { createRouter } from "@tanstack/solid-router";
import { NotFoundRoute } from "@/components/not-found-route";
import { rootRoute } from "@/routes/__root";
import { authRoute } from "@/routes/_auth/route";
import { loginRoute } from "@/routes/_auth/login";
import { registerRoute } from "@/routes/_auth/register";
import { forgotPasswordRoute } from "@/routes/_auth/forgot-password";
import { resetPasswordRoute } from "@/routes/_auth/reset-password";
import { verifyEmailRoute } from "@/routes/_auth/verify-email";
import { socialCallbackRoute } from "@/routes/_auth/social-callback";
import { pluginRoutes } from "@/composition";
import { appRoute } from "@/routes/_app/route";
import { indexRoute } from "@/routes/_app/index";
import { profileRoute } from "@/routes/_app/profile";
import { debugRoute } from "@/routes/_app/debug";
import { organizationsRoute } from "@/routes/_app/organizations";
import { cc21ProbeRoute } from "@/routes/_app/cc21-probe";
import { organizationDetailRoute } from "@/routes/_app/organizations.$orgId";
import { invitationsRoute } from "@/routes/_app/invitations";
import { themeGalleryRoute } from "@/routes/_app/themes";
import { languageRoute } from "@/routes/_app/language";
import { profileFontsRoute } from "@/routes/_app/profile.fonts";
import { profileShortcutsRoute } from "@/routes/_app/profile.shortcuts";
import { profileDeleteAccountRoute } from "@/routes/_app/profile.delete-account";
import { profileTransferSendRoute } from "@/routes/_app/profile.transfer-send";
import { profileTransferReceiveRoute } from "@/routes/_app/profile.transfer-receive";
import { profilePlanRoute } from "@/routes/_app/profile.plan";
// AULA · dominio de cursos
import { catalogRoute } from "@/routes/_app/catalog";
import { catalogCourseRoute } from "@/routes/_app/catalog.$courseId";
import { learnRoute } from "@/routes/_app/learn";
import { learnCourseRoute } from "@/routes/_app/learn.$courseId";
import { leaderboardRoute } from "@/routes/_app/leaderboard";
import { authoringRoute } from "@/routes/_app/authoring";
import { authoringCourseRoute } from "@/routes/_app/authoring.$courseId";
import { certificateRoute } from "@/routes/_app/certificates.$certId";
import { verifyCertificateRoute } from "@/routes/verify.$certId";

const routeTree = rootRoute.addChildren([
  socialCallbackRoute,
  // PUBLIC certificate verification (guest-first, outside /u/<n>).
  verifyCertificateRoute,
  authRoute.addChildren([
    loginRoute,
    registerRoute,
    forgotPasswordRoute,
    resetPasswordRoute,
    verifyEmailRoute,
  ]),
  appRoute.addChildren([
    // CC-21 regression fixture (Select/Popover inside Dialog). DEV only.
    ...(import.meta.env.DEV ? [cc21ProbeRoute] : []),
    indexRoute, // path: "/" — redirige a /learn
    ...pluginRoutes,
    // AULA · cursos
    catalogRoute,
    catalogCourseRoute,
    learnRoute,
    learnCourseRoute,
    leaderboardRoute,
    authoringRoute,
    authoringCourseRoute,
    certificateRoute,
    organizationsRoute,
    organizationDetailRoute,
    invitationsRoute,
    themeGalleryRoute,
    languageRoute,
    profileRoute,
    profileFontsRoute,
    profileShortcutsRoute,
    profileDeleteAccountRoute,
    profileTransferSendRoute,
    profileTransferReceiveRoute,
    profilePlanRoute,
    debugRoute,
  ]),
]);

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  // oxlint-disable-next-line eslint(no-magic-numbers)
  defaultPreloadStaleTime: 30_000,
  defaultNotFoundComponent: NotFoundRoute,
});

declare module "@tanstack/solid-router" {
  interface Register {
    router: typeof router;
  }
}
